var _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPumpkin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2732 0.550906C39.0201 0.07811 38.1604 2.21644 37.4751 6.93157C36.7898 11.6467 37.7632 15.6913 39.6492 15.9654C41.5353 16.2395 43.6198 12.6394 44.3051 7.92423C44.9904 3.2091 45.5264 1.02371 42.2732 0.550906Z",
    fill: "#6A942F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6858,
    cy: 40.236,
    rx: 17.6858,
    ry: 28.9011,
    fill: "#FC751B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3911,
    cy: 40.236,
    rx: 17.6858,
    ry: 28.9011,
    fill: "#FC751B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6844,
    cy: 41.0988,
    rx: 17.6858,
    ry: 28.9011,
    fill: "#FC751B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7822 19.5346C23.7395 21.8241 21.1375 22.2382 18.527 24.3549C17.6039 25.1033 18.527 26.6361 16.6358 28.6968C14.4514 29.6101 13.8226 26.9023 11.9435 26.6361C9.78779 26.3307 6.48939 28.2919 5.7971 26.6361C4.50134 23.537 7.25318 19.4349 11.9435 17.4739C16.6338 15.5129 21.4865 16.4355 22.7822 19.5346Z",
    fill: "#C87749"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6058 40.6674C72.563 42.9569 73.7626 41.5301 72.8783 44.1974C75.9194 46.2751 72.8783 46.4786 70.9871 48.5393C68.8027 49.4526 68.1739 46.7448 66.2948 46.4786C64.1391 46.1733 60.8407 48.1344 60.1484 46.4786C58.8527 43.3795 61.6045 39.2775 66.2948 37.3164C70.9851 35.3554 72.4685 35.9224 71.6058 40.6674Z",
    fill: "#C87749"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpkin);
export default __webpack_public_path__ + "static/media/pumpkin.8805a08385a0ad172e76da3923511e5f.svg";
export { ForwardRef as ReactComponent };